"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postNotifyMeSubscribe = exports.getProductDetailPriceBySku = exports.getComparisonFeatures = exports.getInformation = void 0;
const tslib_1 = require("tslib");
const openapi_fetch_1 = tslib_1.__importDefault(require("openapi-fetch"));
const axios_1 = tslib_1.__importDefault(require("axios"));
const createUrl_1 = require("../../utils/createUrl");
const urlMapping = {
    information: {
        client: '/api/aem/product/productcode',
        server: '/enrichedproduct/productcode',
    },
    comparisonFeatures: {
        client: '/api/aem/product/features/comparison/{market}/{mainWebShopId}/{productId}',
        // server: '/cache/product/features/comparison/{market}/{mainWebShopId}/{productId}',
    },
    productDetailPriceBySku: {
        client: '/api/aem/product/price/sku/{market}/{mainWebShopId}/{fictiveWebShopId}/{productId}/{skuId}',
    },
    notifyMeSubscribe: {
        client: 'api/notifyme/request',
    },
};
const client = (0, openapi_fetch_1.default)();
const getInformation = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ servicesEndpoint, defaultRequestParams, isServer }, { productCode, colorId }) {
    const { data, error } = yield client.GET((0, createUrl_1.getEndpoint)(urlMapping.information, isServer), {
        baseUrl: servicesEndpoint,
        params: {
            // @ts-expect-error incorrect type for mainWebShop
            query: Object.assign(Object.assign({}, defaultRequestParams), { productCode,
                colorId }),
        },
    });
    if (error) {
        throw new Error(error);
    }
    return data;
});
exports.getInformation = getInformation;
const getComparisonFeatures = (_c, _d) => tslib_1.__awaiter(void 0, [_c, _d], void 0, function* ({ servicesEndpoint, defaultRequestParams }, { productId, mainWebShopId }) {
    const { market, language } = defaultRequestParams;
    const { data, error } = yield client.GET(urlMapping.comparisonFeatures.client, {
        baseUrl: servicesEndpoint,
        params: {
            path: { market, mainWebShopId, productId },
            query: { language },
        },
    });
    if (error) {
        throw new Error(error);
    }
    return data;
});
exports.getComparisonFeatures = getComparisonFeatures;
const getProductDetailPriceBySku = (_e, _f) => tslib_1.__awaiter(void 0, [_e, _f], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { mainWebShopId, productId, skuId }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.comparisonFeatures, isServer, {
        market: defaultRequestParams.market,
        fictiveWebShopId: defaultRequestParams.shopId,
        mainWebShopId,
        productId,
        skuId,
    });
    const axiosConfig = {
        url,
        method: 'GET',
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getProductDetailPriceBySku = getProductDetailPriceBySku;
const postNotifyMeSubscribe = (_g, _h) => tslib_1.__awaiter(void 0, [_g, _h], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { productId, skuId, email }) {
    const { mainWebshop, shopId, language } = defaultRequestParams;
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.notifyMeSubscribe, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        params: { mainWebshop, shopId, language },
        data: { productId, skuId, email },
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.postNotifyMeSubscribe = postNotifyMeSubscribe;
//# sourceMappingURL=product.api.js.map